

































































































// vue
import { defineComponent, ref, computed, watch } from '@vue/composition-api';
import { useStore } from '@/store';
import { useRouter } from '@/router';

// services
import { useService } from '@/vue3/api/services';

// lib
import { Portal } from '@linusborg/vue-simple-portal';

export default defineComponent({
    components: {
        Portal,
    },
    setup() {
        // hooks
        const { state, getters } = useStore();
        const router = useRouter();
        const {
            logOut,
            getAccount,
            getAllPermissionNameByAccountId,
            getOrganization,
            getCourseSchemas,
            addState,
        } = useService();

        const isMultiUser = computed(()=>{
            const isMasq = JSON.parse(
                localStorage.getItem('tempAuthToken') as string);
            if(isMasq){
                return false;
            }
            const multiUserFlag1 = (state.accountPermissions != null ? (state.accountPermissions.indexOf('canEnableMultiOrgAccount') !== -1 || state.multiUserAuthToken) : false);
            const multiUserFlag2 = ref<any>(JSON.parse(localStorage.getItem('multiUserAuthToken') as string));
            if(multiUserFlag2 || multiUserFlag1){
                return true;
            }
            return false;
        })

        // computed
        const links = computed(() => {
            let linkArray: any[] = [
                { route: '/my-account', title: 'My Account' },
                { route: '/feedback', title: 'Feedback' },
                { route: '/privacy-policy', title: 'Privacy Policy' },
                { route: '/settings', title: 'Settings' },
            ];

            if(isMultiUser.value){
                linkArray.splice(1, 0, { route: '/switch-account', title: 'Switch Account' })
            }

            if (JSON.parse(state.tempAuthToken as string)) {
                linkArray.push({
                    id: 'revertToAdministrator',
                    route: '/admin/accounts',
                    title: 'Revert to Administrator',
                });
            }

            return linkArray;
        });

        const notificationsCount = ref(state.notificationCount || 0);

        // reactive
        const isMenuVisible = ref(false);

        // methods
        const toggleIsMenuVisible = () => {
            isMenuVisible.value = !isMenuVisible.value;
        };

        watch(
            () => state.notificationCount,
            () => {notificationsCount.value = state.notificationCount},
        );

        const clickLink = async (link: any) => {
            toggleIsMenuVisible();
            if (link.id === 'revertToAdministrator') {
                await revertToAdmin();
            }
            router.push({ path: link.route });
        };

        const revertToAdmin = async () => {
            state.tempAuthToken = null;
            state.masqueradeAccountPermissions = null;

            localStorage.removeItem('tempAuthToken');
            localStorage.removeItem('masqueradeAccountPermissions');

            const permsProm = getAllPermissionNameByAccountId(
                JSON.parse(state.authToken as string).accountId,
            );

            const orgProm = getOrganization(
                JSON.parse(state.authToken as string).organizationId,
            );

            const coursesProm = getCourseSchemas();

            const accountProm = getAccount(
                JSON.parse(state.authToken as string).accountId,
            );

            const perms = await permsProm;
            const org = await orgProm;
            const courses = await coursesProm;
            const account = await accountProm;

            addState('account', account);
            addState('accountPermissions', perms);
            addState('courseSchemas', courses);
            addState('currentOrganization', org);

            if (!localStorage.getItem('currentCourseSchema')) {
                if (JSON.parse(state.courseSchemas as string).length > 0) {
                    state.currentCourseSchema = JSON.stringify(
                        JSON.parse(state.courseSchemas as string)[0],
                    );
                    localStorage.setItem(
                        'currentCourseSchema',
                        JSON.stringify(
                            JSON.parse(state.courseSchemas as string)[0],
                        ),
                    );
                }
            }
            window.location.reload();
        };

        return {
            account: getters.account,
            isMasquereded: JSON.parse(
                localStorage.getItem('tempAuthToken') as string,
            ),
            organization: getters.currentOrganization,
            isMultiUser,
            masquerededName: localStorage.getItem('masquerededUserName'),
            logOut,
            isMenuVisible,
            toggleIsMenuVisible,
            links,
            clickLink,
            notificationsCount,
        };
    },
});
